import React from 'react'
import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import { Button } from 'src/design_system/components/Button/Button'
import { useSelector } from 'src/hooks'

const memberAvatarIds = Array.from({ length: 35 }, (_, index) => index + 1)

const COMMUNITY_URL =
  'https://community.promptings.com/communities/groups/promptings-community/home'
const COMMUNITY_IMAGE_URL =
  'https://soc-website-public.s3.us-west-2.amazonaws.com/static/soc-website/images/manual/PromptingsCommunityFlattened.png'

export const PromptingsCommunityWidget: React.FC = () => {
  const windowWidth = useSelector(state => state.window.width)
  const isMobile = windowWidth <= 516
  const isWide = windowWidth > 1260

  return (
    <Flex
      width="100%"
      flexDirection="column"
      backgroundColor="#fff"
      alignItems="center"
      borderRadius="32px"
      minWidth="340px"
      height="inherit"
      inset="16px"
      minHeight={isWide ? '824px' : undefined}
      style={{ boxShadow: 'rgba(0, 0, 0, 0.04) 0px 4px 32px' }}
    >
      <Flex
        flexDirection="column"
        width="100%"
        height="100%"
        rowGap="x2"
        style={{ minHeight: 0 }}
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          width="100%"
          borderRadius="24px"
          flexDirection="column"
        >
          <Flex>
            <div
              style={{
                borderRadius: '20px',
                cursor: 'pointer',
                overflow: 'hidden',
              }}
              onClick={() => window.open(COMMUNITY_URL, '_blank', 'noreferrer')}
            >
              <img
                src={COMMUNITY_IMAGE_URL}
                alt="Promptings community"
                style={{
                  display: 'block',
                  width: '100%',
                  height: 'auto',
                }}
              />
            </div>
          </Flex>
          <Flex width="100%" inset={{ horizontal: 'x2' }}>
            <Text
              inset={{ vertical: 'x2' }}
              type="subtitle"
              weight="semiBold"
              alignment="left"
              content="Promptings Community"
            />
          </Flex>
        </Flex>
        <Flex
          flexDirection="column"
          inset={{ horizontal: 'x2', bottom: 'x2' }}
          rowGap="x1_5"
          style={{ flex: 1, minHeight: 0 }}
        >
          <Flex
            flexDirection="column"
            rowGap="x1_5"
            inset={{ vertical: 'x1', horizontal: 'x1' }}
          >
            <Text type="footnote" color="primaryBody" content="Private Group" />
            <Text
              type="body"
              color="primaryBody"
              content="A community inspiring gratitude, connection, and acting on promptings. Share stories, and everyday acts that transform lives."
            />
            <Flex flexDirection="column" rowGap="x_5">
              <Text
                type="body"
                color="primaryHeading"
                weight="semiBold"
                content="Promptings Website"
              />
              <Text
                type="body"
                color="primaryBody"
                content="SendOutCards Website"
              />
            </Flex>
          </Flex>
          <Flex
            flexDirection="column"
            rowGap="x1"
            inset={{ vertical: '8px' }}
            style={{ flex: 1, minHeight: 0, justifyContent: 'flex-end' }}
          >
            <Button
              title="Join Community"
              onClick={() => window.open(COMMUNITY_URL, '_blank', 'noreferrer')}
              background="#424448"
              textColor="#fff"
              textSize="14px"
              width="100%"
              borderRadius="10px"
            />
            <div
              style={{
                borderTop: '1px solid #e5e7eb',
                width: '100%',
                marginTop: '16px',
                marginBottom: '16px',
              }}
            />
            <Flex
              columnGap="x_25"
              style={{
                flexWrap: 'nowrap',
                overflowX: 'hidden',
                overflowY: 'hidden',
                position: 'relative',
                width: '100%',
              }}
            >
              {memberAvatarIds.map(id => (
                <Flex
                  key={id}
                  width="28px"
                  height="28px"
                  borderRadius="circle"
                  style={{
                    backgroundImage: `url(https://i.pravatar.cc/48?img=${id})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    flexShrink: 0,
                  }}
                />
              ))}
              {isMobile && (
                <Flex
                  alignItems="center"
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    height: '100%',
                    paddingLeft: '6px',
                    background:
                      'linear-gradient(90deg, rgba(255, 255, 255, 0), #fff 60%)',
                    pointerEvents: 'none',
                  }}
                >
                  <Text type="footnote" weight="semiBold" content="..." />
                </Flex>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default PromptingsCommunityWidget
